export default [
	{"text": "Para conocerse",      "identifier": "conocimiento"},
	{"text": "Pruebas pequeñas",    "identifier": "pequeñas"},
	{"text": "De pensar",           "identifier": "pensar"},
	{"text": "Pasar el rato",       "identifier": "entretenidas"},
	{"text": "De confianza",        "identifier": "confianza"},
	{"text": "Por equipos",         "identifier": "equipo"},
	{"text": "Reflexiones",         "identifier": "reflexion"}
];
